import { render, staticRenderFns } from "./PurchaseDialog.vue?vue&type=template&id=e337b6dc&scoped=true&"
import script from "./PurchaseDialog.vue?vue&type=script&lang=js&"
export * from "./PurchaseDialog.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDialog.vue?vue&type=style&index=0&id=e337b6dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e337b6dc",
  null
  
)

export default component.exports